import { getTrackingSection } from '@/modules/misc/common/navbar/utils/trackingSection';

// It's like a Popover component but implemented in Vanilla JS
export default class DropdownHandler {
  wrapper;

  // Class which is added on the start, for example with opacity: 0 and display: block, so that the transition can work
  wrapperClassNameStart;

  wrapperClassNameAnimating;

  wrapperClassName;

  dropdown;

  isOpen = false;

  maximumHeight = '100vh';

  isMobile = false;

  animationTime = 300;

  updateHeightTimeout;

  user = null;

  onClose = null;

  constructor(props) {
    this.dropdown = props.dropdown;
    this.wrapper = props.wrapper;
    this.wrapperClassNameStart = `${props.wrapperClassName}-start`;
    this.wrapperClassNameAnimating = `${props.wrapperClassName}-animating`;
    this.wrapperClassName = props.wrapperClassName;
    this.maximumHeight = props.maximumHeight ? props.maximumHeight : this.maximumHeight;
    this.isMobile = props.isMobile;
    this.user = props.user;
    this.onClose = props.onClose ?? null;
    this.setMaxHeight('0');
  }

  startListening() {
    this.wrapper.addEventListener('click', event => {
      const isTargetDropdown = this.dropdown.contains(event.target);
      if (!isTargetDropdown) {
        this.toggleOpen();
      }
    });

    document.addEventListener('click', event => {
      if (!this.isOpen) {
        return;
      }
      const isTargetDropdown = this.wrapper.contains(event.target);
      if (!isTargetDropdown) {
        this.closeDropdown();
      }
    }, true);

    // Track clicks on dropdown links
    if (this.dropdown) {
      this.dropdown.addEventListener('click', event => {
        const link = event.target.closest('a.ds-header__navbar__nav__link');
        // A row that opens a sub-panel is not a destination; counting it as a dropdown link click
        // would report a visit to a page nobody has gone to yet.
        if (link && !link.dataset.panelTarget && this.isMobile && this.user) {
          this.trackNavbarInteraction(link.textContent.trim());
        }
      });
    }
  }

  trackNavbarInteraction(linkText = null) {
    const section = getTrackingSection(this.user.type);
    const element = this.user.type === 'guest' ? 'avatar_toggle' : 'header_avatar';

    const eventData = {
      section,
      element,
      interaction: 'click',
    };

    if (linkText) {
      eventData.element_value = linkText;
    }

    if (window.App?.track?.event) {
      window.App.track.event('navbar_interaction', eventData);
    }
  }

  setMaxHeight(value) {
    this.dropdown.style.maxHeight = value;
  }

  // The layered menu resizes the sheet as the viewer drills in: a sub-panel covers the page header,
  // so it is a screen tall where the root panel is a screen less the header.
  setMaximumHeight(value) {
    this.maximumHeight = value;

    if (this.isOpen) {
      this.setMaxHeight(value);
    }
  }

  updateMaxHeightValue() {
    const height = this.dropdown.getBoundingClientRect().height;
    if (height < 100) {
      return;
    }
    this.maximumHeight = `${height}px`;
    this.setMaxHeight(this.maximumHeight);
  }

  toggleOpen() {
    this.wrapper.setAttribute('disabled', 'true');

    clearTimeout(this.updateHeightTimeout);

    // Desktop avatar opens have never been tracked. The ticket asks for them on the manager navbar;
    // guests and customers keep the mobile-only gate so their historical series stay comparable.
    const shouldTrackToggle = this.isMobile || this.user?.type === 'manager';

    if (this.user && shouldTrackToggle) {
      this.trackNavbarInteraction();
    }

    if (this.isOpen) {
      this.closeDropdown();
      return;
    }

    this.isOpen = true;
    this.wrapper.classList.add(this.wrapperClassNameStart);
    this.wrapper.classList.add(this.wrapperClassNameAnimating);

    if (this.isMobile) {
      document.documentElement.style.overflow = 'hidden';
    }

    setTimeout(() => {
      this.wrapper.classList.add(this.wrapperClassName);
      this.setMaxHeight(this.maximumHeight);
    });

    this.updateHeightTimeout = setTimeout(() => {
      this.updateMaxHeightValue();
      this.wrapper.classList.remove(this.wrapperClassNameAnimating);
    }, this.animationTime + 50);

    this.wrapper.removeAttribute('disabled');
  }

  closeDropdown() {
    this.wrapper.setAttribute('disabled', 'true');
    this.isOpen = false;

    if (this.onClose) {
      this.onClose();
    }

    if (this.isMobile) {
      document.documentElement.style.overflow = 'visible';
    }

    this.setMaxHeight('0');
    this.wrapper.classList.remove(this.wrapperClassName);
    this.wrapper.classList.add(this.wrapperClassNameAnimating);
    setTimeout(() => {
      this.wrapper.classList.remove(this.wrapperClassNameStart);
      this.wrapper.classList.remove(this.wrapperClassNameAnimating);
      this.wrapper.removeAttribute('disabled');
    }, this.animationTime);
  }
}
